import styled from "styled-components";
import {SearchInputMobileDefaultBox} from "./search-input-mobile.default.box";

export const SearchInputMobileCasino777Box = styled(SearchInputMobileDefaultBox)`
      border-radius: 5px;
      box-shadow: 2px 3px 1rem rgba(25,50,48,0.2);
`;